module.exports = __webpack_public_path__ + "media/images/CBTL-3ba1d953f9c3dcba525b2e86cfae8f9b.png";